export const getArtistImageById = (id: string) => {
  return new URL(
    `g/${id}?s=small`,
    process.env.REACT_APP_ASSETS_BASE_URL.replace(/([^\/])$/, "$1/"),
  ).toString();
};
